import { render, staticRenderFns } from "./deposit_Admin_kr.vue?vue&type=template&id=5d83e840&scoped=true&"
import script from "./deposit_Admin_kr.vue?vue&type=script&lang=js&"
export * from "./deposit_Admin_kr.vue?vue&type=script&lang=js&"
import style0 from "./deposit_Admin_kr.vue?vue&type=style&index=0&id=5d83e840&prod&scoped=true&lang=css&"
import style1 from "./deposit_Admin_kr.vue?vue&type=style&index=1&id=5d83e840&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d83e840",
  null
  
)

export default component.exports